var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReinviteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9494_77776)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.16667 2C1.53486 2 1.83333 2.29848 1.83333 2.66667V6H5.16667C5.53486 6 5.83333 6.29848 5.83333 6.66667C5.83333 7.03486 5.53486 7.33333 5.16667 7.33333H1.16667C0.798477 7.33333 0.5 7.03486 0.5 6.66667V2.66667C0.5 2.29848 0.798477 2 1.16667 2Z",
    fill: "#FB7B33"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.57024 1.40457C9.00152 1.20319 10.4595 1.47243 11.7244 2.17171C12.9894 2.87099 13.9928 3.96244 14.5835 5.28159C15.1742 6.60074 15.3202 8.07614 14.9995 9.48549C14.6788 10.8948 13.9088 12.1618 12.8054 13.0954C11.702 14.0291 10.3251 14.5788 8.88212 14.6619C7.43913 14.7449 6.00824 14.3568 4.80504 13.5559C3.60184 12.755 2.69151 11.5848 2.21122 10.2215C2.08887 9.87425 2.2712 9.49355 2.61847 9.3712C2.96574 9.24886 3.34644 9.43119 3.46879 9.77846C3.85302 10.8691 4.58128 11.8052 5.54384 12.4459C6.5064 13.0866 7.65112 13.3972 8.80551 13.3307C9.9599 13.2643 11.0614 12.8245 11.9441 12.0776C12.8268 11.3307 13.4429 10.3171 13.6994 9.18963C13.956 8.06216 13.8392 6.88184 13.3666 5.82652C12.8941 4.77119 12.0913 3.89804 11.0794 3.33861C10.0674 2.77919 8.90102 2.5638 7.756 2.7249C6.61098 2.88599 5.54933 3.41485 4.73101 4.23179C4.72625 4.23654 4.72142 4.24122 4.71652 4.24582L1.62319 7.15249C1.35487 7.40462 0.932961 7.39149 0.680833 7.12317C0.428706 6.85485 0.441831 6.43295 0.710151 6.18082L3.79633 3.28088C4.81823 2.26386 6.14238 1.60546 7.57024 1.40457Z",
    fill: "#FB7B33"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReinviteIcon);
export default __webpack_public_path__ + "static/media/reinvite-icon.9905c52d9b7ad0477ad3b6b3e5e015b7.svg";
export { ForwardRef as ReactComponent };